import { Button, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";

export default function MyModal({
  isOpen,
  setIsOpen,
  children,
  isTransparent = false,
  onCloseModal,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  children: React.ReactNode;
  isTransparent?: boolean;
  onCloseModal?: () => void;
}) {
  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
    onCloseModal && onCloseModal();
  }

  return (
    <>
      <Dialog
        open={isOpen}
        as="div"
        className="relative z-10 focus:outline-none"
        onClose={close}
        __demoMode
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className={`shadow-lg w-fit rounded-xl ${
                !isTransparent && "bg-white"
              } p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0`}
            >
              {children}
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}
